import { gql } from '@apollo/client'
import { format } from 'date-fns'
import { useEffect, useState } from 'react'

import { MOONBEAM } from '../../config/chains'
import { SUBGRAPH_URLS } from '../../config/subgraphs'
import { roundDownToNearestDay } from '../numbers'
import { createClient } from '../useClient'

export default function useUserStats(params) {
  const [userStats, setUserStats] = useState([])
  const client = createClient(SUBGRAPH_URLS[MOONBEAM].stats)

  useEffect(() => {
    if (!params.fromValue || !params.toValue) {
      return
    }

    const start = roundDownToNearestDay(params.fromValue)
    const end = roundDownToNearestDay(params.toValue)

    const userStatsQuery = gql`
      query dailyUserStats($start: Int!, $end: Int!) {
        userStats(
          first: 1000
          orderBy: timestamp
          orderDirection: asc
          where: { period: daily, timestamp_gte: $start, timestamp_lte: $end }
        ) {
          timestamp
          uniqueCount
          uniqueSwapCount
          uniqueMarginCount
          uniqueMintBurnCount
          # uniqueCountCumulative
          # uniqueSwapCountCumulative
          # uniqueMarginCountCumulative
          # uniqueMintBurnCountCumulative
        }
      }
    `

    const getUserStats = async () => {
      client
        .query({
          query: userStatsQuery,
          variables: { start: start, end: end },
        })
        .then(({ data }) => {
          const { userStats } = data
          const chartData = userStats.map((el) => {
            const d = new Date(el.timestamp * 1000)
            return {
              x: format(d, 'do MMM yyyy'),
              cnt: parseInt(el.uniqueCount),
              cntSwap: parseInt(el.uniqueSwapCount),
              cntMargin: parseInt(el.uniqueMarginCount),
              cntMintBurn: parseInt(el.uniqueMintBurnCount),
            }
          })

          setUserStats(chartData)
        })
    }

    getUserStats()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params])

  return userStats
}
